export default new Map<string, string>([['true', 'con-terrazzo']]);
